












































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { BillingModule } from '@/store/dashboard/billing/BillingModule';
import { resolveModule } from '@/store';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { BillingPeriodRow } from '@/modules/backend/Billing/BillingPeriodRow';
import { DataTableHeader } from 'vuetify';
import BaseMixin from '@/mixins/base';
import SortMixin from '@/mixins/sort';
import { currency } from '@/filters/currency';

@Component({
  mixins: [BaseMixin, SortMixin],
  filters: {
    currency
  },
  components: {
    'data-table-wrapper': DataTableWrapper
  }
})
export default class BillingReportComponent extends Mixins(BaseMixin, SortMixin) {
  private readonly billingModule: BillingModule = resolveModule(BillingModule);

  @Prop({ required: true, type: Number }) private readonly accountId!: number;

  private loading = false;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.$t('screens.account.billing.table.headers.sn').toString(),
        sortable: false,
        value: 'sn'
      },
      {
        text: this.$t('screens.account.billing.table.headers.placement').toString(),
        value: 'placement'
      },
      {
        text: this.$t('screens.account.billing.table.headers.resource').toString(),
        value: 'resource'
      },
      {
        text: this.$t('screens.account.billing.table.headers.value_last').toString(),
        value: 'value_last'
      },
      {
        text: this.$t('screens.account.billing.table.headers.value').toString(),
        value: 'value'
      },
      {
        text: this.$t('screens.account.billing.table.headers.value_diff').toString(),
        value: 'value_diff'
      },
      {
        text: this.$t('screens.account.billing.table.headers.rate').toString(),
        value: 'rate'
      },
      {
        text: this.$t('screens.account.billing.table.headers.cost').toString(),
        value: 'cost',
      }
    ];
  }

  private get items(): BillingPeriodRow[] {
    if (!this.billingModule.report) {
      return [];
    }

    return this.billingModule.report.rows;
  }

  private get hasReport(): boolean {
    return Boolean(this.billingModule.report && this.billingModule.report.rows) || false;
  }

  private customSort(items: BillingPeriodRow[], index: string[], isDescending: boolean[]): BillingPeriodRow[] {
    items.sort((a, b): number => {
      if (index[0] === 'placement' && a.counter && b.counter) {
        return this.stringComparator(
          a.counter.getNote(),
          b.counter.getNote(),
          isDescending[0]
        );
      }

      if (index[0] === 'resource') {
        return this.stringComparator(
          a.rate.getResource().getTitle(),
          b.rate.getResource().getTitle(),
          isDescending[0]
        );
      }

      if (index[0] === 'value_last') {
        return this.numberComparator(
          a.data[0].getValue(),
          b.data[0].getValue(),
          isDescending[0]
        );
      }

      if (index[0] === 'value') {
        return this.numberComparator(
          a.data[a.data.length - 1].getValue(),
          b.data[b.data.length - 1].getValue(),
          isDescending[0]
        );
      }

      if (index[0] === 'value_diff') {
        return this.numberComparator(
          a.data[a.data.length - 1].getValue() - a.data[0].getValue(),
          b.data[b.data.length - 1].getValue() - b.data[0].getValue(),
          isDescending[0]
        );
      }

      if (index[0] === 'rate') {
        return this.numberComparator(
          a.rate.getPrice(),
          b.rate.getPrice(),
          isDescending[0]
        );
      }

      if (index[0] === 'cost') {
        return this.numberComparator(
          a.summary,
          b.summary,
          isDescending[0]
        );
      }

      return 0;
    });

    return items;
  }

  private async updateData(): Promise<void> {
    this.loading = true;
    await this.billingModule.fetchReport({
      accountId: this.accountId,
      from: new Date(new Date().setDate(1)),
      to: new Date()
    });
    this.loading = false;
  }

  @Watch('accountId')
  private async accountIdChangeHandler(): Promise<void> {
    await this.updateData();
  }

  public async mounted(): Promise<void> {
    await this.updateData();
  }
}
